module.exports = __webpack_public_path__ + "img/ic_link_history.da5886be.svg";